import customAlert from '@/utils/customAlert/customAlert';
import auth from '@/services/auth.services';

export function successHandler(cfg) {
  return cfg;
}

export function errorHandler(cfg) {
  if (!cfg?.request?.status) {
    customAlert({
      type: 'error',
      msg: 'Network error'
    });
    return cfg;
  }
  if ([403].includes(cfg.request.status)) {
    customAlert({
      type: 'error',
      msg: 'Session expirated'
    });
    auth.logout(false, 5000);
    throw 'session expirated';
  }
  if ([401].includes(cfg.request.status)) {
    customAlert({
      type: 'error',
      msg: 'Unauthorized'
    });
    auth.logout(false, 2000);
  }
  return cfg;
}
